import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventGroupHeader6Pack } from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventGroupHeader6Pack';
import {
    getMarketNameMLB,
    getMarketNameMLBUnified,
} from 'src/domains/sportsbook/webview/components/eventsList/eventRowMLB/EventRowMLB.state';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    label: string;
    onToggle: () => void;
    open: boolean;
}

export const EventGroupHeaderMLB = observer('EventGroupHeaderMLB', (props: EventGroupHeaderPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const { unifiedSportEventsTable } = ConfigComponents.get(common).unifiedComponentConfig;
    const { dataTest, label, open, onToggle } = props;

    const marketNames =
        unifiedSportEventsTable === true
            ? getMarketNameMLBUnified(languagesState.getTranslation)
            : getMarketNameMLB(languagesState.getTranslation);

    return (
        <EventGroupHeader6Pack
            dataTest={dataTest}
            label={label}
            marketNames={marketNames}
            onToggle={onToggle}
            open={open}
        />
    );
});
